export default __webpack_public_path__ + "static/media/Illustration  Loading the Setting.ddb9bb83.svg";